export default {
  'menu.main': '首页',
  'menu.data': '信息库',
  'menu.data.bean-info': '生豆信息库',
  'menu.data.region-story': '产地故事',
  'menu.data.region-price': '产地限价',
  'menu.data.bean-info-detail': '生豆详情',
  'menu.data.bean-info-notes': '品鉴笔记',
  'menu.form': '表单管理',
  'menu.form.bean-consult': '寻豆',
  'menu.form.purchase-intention': '采购意向',
  'menu.form.contact-us-form': '联系我们',
  'menu.system': '系统管理',
  'menu.system.diction': '词典',
  'menu.system.operate-log': '操作日志',
  'menu.system.user': '用户管理',
  'menu.system.info': '信息配置',
};
